import Types from '../types';

const INITIAL_STATE = {};

export default (reducerState = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.SET_ANNOUNCEMENT:
      return action.payload;
    default:
      return reducerState;
  }
};
